<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Bachelor of Science</h2>
          <ul class="breadcrumb">
            <li>
              <a roterLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Bachelor of Science</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="computer-application ptb--100  horizontal--tab">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <p>Bachelor of Science (BSc) is an undergraduate degree course usually of three years duration. It is one of the
          most popular course choices among Science students after Class 12th. Full form of BSc is Bachelor of Science,
          The course is considered as a foundation course for students who want make their career in the field of
          Science. It is offered in a variety of Science subjects. Some of the popular BSc courses that students usually
          choose to pursue after Class 12th are BSc Physics, Chemistry, Biology, Mathematics, Electronics, zoology and
          Statistics.</p>
      </div>
      <div class="col-12 text-center">
        <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button mt-3">Apply Now</a>
      </div>
    </div>
  </div>
</section>
